import { configureStore } from "@reduxjs/toolkit";
import { appVersionSlice } from "./slices/appVersion.slice";
import authSlice from "./slices/auth.slice";
import companySettingsSlice from "./slices/company-settings.slice";
import enumsSlice from "./slices/enums.slice";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    companySettings: companySettingsSlice.reducer,
    appVersion: appVersionSlice.reducer,
    enums: enumsSlice.reducer,
  },
});

export class StoreKeeper {
  public static store: typeof store;
}

export type RootState = ReturnType<typeof store.getState>;
StoreKeeper.store = store;
